import script from "./PCSideNavbarItem.vue?vue&type=script&setup=true&lang=js"
export * from "./PCSideNavbarItem.vue?vue&type=script&setup=true&lang=js"

import "./PCSideNavbarItem.vue?vue&type=style&index=0&id=7fe19fb4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fe19fb4"]])

export default __exports__